module.exports = __webpack_public_path__ + "static/media/Last.9b12855d.svg";